import React, {useEffect, useState} from "react";
import {HeaderMenuItem} from "../../../config/HeaderMenu";
import Button from "../../../components/ui/button/Button";
import {useTranslation} from "gatsby-plugin-react-i18next";
import {Link} from "gatsby";
import SvgChevron from "../../../components/ui/icons/SvgChevron";
import './header.scss';
import {animated, useSpring} from "@react-spring/web";

interface Props {
    menuItem: HeaderMenuItem
}

const HeaderButtonWithSubmenus = ({
                                  menuItem,
                              }: Props) => {
    const {t} = useTranslation('common');
    const [isVisible, setIsVisible] = useState<boolean>(false);

    const [animatedStyles, api] = useSpring(() => ({
        from: {
            maxHeight: 0,
        },
    }), []);

    const animateOpen = () => {
        api.start({
            to: {
                maxHeight: 600,
            },
        });
    };

    const animateClose = () => {
        api.start({
            to: {
                maxHeight: 0,
            },
        });
    };

    useEffect(() => {
        if(isVisible) animateOpen();
        else animateClose();
    }, [isVisible]);

    return (
        <div
            className='submenuContainer'
            onMouseEnter={() => setIsVisible(true)}
            onMouseLeave={() => setIsVisible(false)}
            onClick={() => setIsVisible(visible => !visible)}
        >
            <Button
                textOnly
                label={t(menuItem.title)}
                className='submenuButton'
            />
            <animated.div
                className="submenu"
                style={animatedStyles}
            >
                <div className="submenuContent">
                    {
                        Object.keys(menuItem?.routes ?? []).map(routeKey => {
                            const route = menuItem?.routes?.[routeKey];
                            if(!route?.route) return ;
                            if(route?.route?.includes('http')){
                                return (
                                    <a
                                        href={route?.route}
                                        target='_blank'
                                        className={["menuItem", "submenuButton"].join(' ')}
                                        role='button'
                                        rel='noreferrer'
                                        key={route?.route}
                                    >
                                        <h3 className='menuItemEmoji'>{route?.emoji}</h3>
                                        <div className='menuItemTexts'>
                                            <p className='menuItemTitle'>{t(route?.title)}</p>
                                            {
                                                route?.subtitle ? (<p className='menuItemSubtitle'>{t(route?.subtitle)}</p>) : null
                                            }
                                        </div>
                                        <SvgChevron />
                                    </a>
                                );
                            }
                            return (
                                <Link
                                    to={route?.route}
                                    className={["menuItem", "submenuButton"].join(' ')}
                                    role='button'
                                    key={route?.route}
                                >
                                    {
                                        route?.emoji ? (<h3 className='menuItemEmoji'>{route?.emoji}</h3>) : null
                                    }
                                    <div className='menuItemTexts'>
                                        <p className="menuItemTitle">{t(route?.title)}</p>
                                        {
                                            route?.subtitle ? (<p className='menuItemSubtitle'>{t(route?.subtitle)}</p>) : null
                                        }
                                    </div>
                                    <SvgChevron />
                                </Link>
                            );
                        })
                    }
                </div>
            </animated.div>
        </div>
    );
};

export default HeaderButtonWithSubmenus;